import { render } from "./RecoverLogin.vue?vue&type=template&id=4e083f46&scoped=true"
import script from "./RecoverLogin.vue?vue&type=script&lang=js"
export * from "./RecoverLogin.vue?vue&type=script&lang=js"

import "./RecoverLogin.vue?vue&type=style&index=0&id=4e083f46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e083f46"]])

export default __exports__